import Select from '../ui/select'
import SelectionRow from '../ui/SelectionRow'
import { useTranslation } from 'react-i18next'

function Row(props) {
  return (
    <div className="ul-border-b ul-border-dark ul-border-opacity-10 ul-mx-20 md:ul-px-20 md:ul-mx-0">
      <SelectionRow {...props} />
    </div>
  )
}

export default function Passengers({
  numAdults,
  numChildren,
  numBabies,
  onNumAdultsChange,
  onNumChildrenChange,
  onNumBabiesChange,
  cabinClass,
  onCabinClassChange,
}) {
  const { t } = useTranslation()
  const limit = 9

  return (
    <div className="ul-bg-white ul-flex ul-flex-col md:ul-mt-5 md:ul-rounded-5 md:ul-shadow-double ul-w-350 ul-z-10 ul-shadow-double">
      <div className="ul-pt-10">
        <Row
          label={t('components.passengers.adultsLabel')}
          subLabel={t('components.passengers.adultsSubLabel')}
          min={1}
          max={limit - numBabies - numChildren}
          value={numAdults}
          srValue={t('components.passengers.adultsSrValue', {
            count: numAdults,
          })}
          onAdd={() => {
            onNumAdultsChange(numAdults + 1)
          }}
          onSubtract={() => {
            onNumAdultsChange(numAdults - 1)

            if (numBabies > numAdults - 1) {
              onNumBabiesChange(numBabies - 1)
            }
          }}
        />
        <Row
          label={t('components.passengers.childrenLabel')}
          subLabel={t('components.passengers.childrenSubLabel')}
          min={0}
          max={limit - numAdults - numBabies}
          value={numChildren}
          srValue={t('components.passengers.childrenSrValue', {
            count: numChildren,
          })}
          onAdd={() => {
            onNumChildrenChange(numChildren + 1)
          }}
          onSubtract={() => {
            onNumChildrenChange(numChildren - 1)
          }}
        />
        <Row
          label={t('components.passengers.babiesLabel')}
          subLabel={t('components.passengers.babiesSubLabel')}
          min={0}
          max={numAdults}
          value={numBabies}
          srValue={t('components.passengers.babiesSrValue', {
            count: numBabies,
          })}
          onAdd={() => {
            onNumBabiesChange(numBabies + 1)
          }}
          onSubtract={() => {
            onNumBabiesChange(numBabies - 1)
          }}
        />
      </div>
      <div className="ul-flex ul-p-20">
        <Select
          id="cabin-class-select"
          label={t('components.passengers.cabinClassLabel')}
          options={[
            {
              value: 'economy',
              label: t('components.passengers.cabinClass.economy'),
            },
            {
              value: 'business',
              label: t('components.passengers.cabinClass.business'),
            },
            {
              value: 'first',
              label: t('components.passengers.cabinClass.first'),
            },
          ]}
          value={cabinClass}
          onChange={(e) => {
            onCabinClassChange(e.target.value)
          }}
        />
      </div>
    </div>
  )
}
